// extracted by mini-css-extract-plugin
export default {"gredientFlow":"WorkFlowSection_gredientFlow__6qLpB","borderFlow":"WorkFlowSection_borderFlow__iqYGF"};